module.exports = __webpack_public_path__ + "static/media/bulldozer_turquoise.19b2190d.svg";